import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { setContentManagerExchange, setContentManagerMoveTo } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { setFiles } from "../../../src/taskpane/redux/modules/file";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_MoveToCancel(selectedItems: any[], waitFor: boolean) {
    const languageStrings = React.useContext(LanguageContext);
    
    const dispatch = useDispatch();
    
    const moveToEnabled = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.moveToEnabled);

    const [menuItem_MoveToCancel, setMenuItem_MoveToCancel] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (moveToEnabled) {
            setMenuItem_MoveToCancel(
                {
                    key: "moveToCancel",
                    text: `${languageStrings.Cancel}`,
                    iconProps: { iconName: "ChromeClose" },
                    onClick: () => {
                        dispatch(setContentManagerMoveTo({
                            moveToEnabled: false,
                            workingDirectories: [],
                            selectedFiles: [],
                            siteUrl: "",
                            sourceServerRelPath: "",
                        }));
                        dispatch(setContentManagerExchange({selectedFolderId: "", selectedFolderName: "", selectedAccount: "" }));
                        dispatch(setFiles([]));
                    }
                }
            )
        } else {
            setMenuItem_MoveToCancel(null)
        }
    }, [selectedItems, moveToEnabled])

    return {
        menuItem_MoveToCancel
    }

}